import { render, staticRenderFns } from "./AdminUpdate.vue?vue&type=template&id=5406dcb4&"
import script from "../../services/admin/admin-update.js?vue&type=script&lang=js&"
export * from "../../services/admin/admin-update.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports